import type { ReactNode } from 'react';

/**
 * A handful of mutually exclusive views of one list — "All · Setting up · Live
 * · Needs attention", "Everyone · The owner · Operators".
 *
 * Buttons with `aria-pressed` inside a labelled group, rather than radio
 * inputs, because what is chosen is a *filter on what is shown*, not an answer
 * being submitted: nothing is written when one is pressed. For an answer that
 * is saved, use real radios in a form.
 */
export interface SegmentedOption<K extends string> {
  id: K;
  label: string;
}

export function Segmented<K extends string>({
  label,
  options,
  value,
  onChange,
}: {
  /** What the group chooses, for the screen reader — the buttons say which. */
  label: string;
  options: readonly SegmentedOption<K>[];
  value: K;
  onChange: (next: K) => void;
}): ReactNode {
  return (
    <div className="seg" role="group" aria-label={label}>
      {options.map((option) => (
        <button
          key={option.id}
          type="button"
          aria-pressed={option.id === value}
          onClick={() => onChange(option.id)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
